var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector86(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 320,
    viewBox: "0 0 342 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.265 318.965C316.028 299.364 312.187 295.095 296.833 274.982C293.071 270.055 287.152 260.475 281.499 248.643C279.805 245.102 278.269 241.591 276.861 238.129C266.815 213.354 265.397 185.599 267.731 158.188C273.689 88.2498 235.832 25.1271 178.513 6.72534C121.096 -11.7059 57.3369 18.6162 26.2254 65.9336C22.1777 72.0905 4.32229 101.144 1.68288 133.02C-6.67852 233.664 90.8121 273.88 239.151 304.33C242.036 304.921 255.775 307.173 258.69 307.576L340.275 318.975L340.265 318.965Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector86);
export default __webpack_public_path__ + "static/media/vector8-6.b258e8d59298276b930d440e06056f10.svg";
export { ForwardRef as ReactComponent };